import { BelgiumMap } from "./belgium-map";
import { motion } from "framer-motion";

export function BelgiumMapDemo() {
  return (
    <div className="py-20 bg-white w-full">
      <div className="text-center px-4 mb-12">
        <motion.p 
          className="font-bold text-xl md:text-4xl text-blue-900 mb-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Nous Intervenons en{" "}
          <span className="text-orange-500">
            {"Belgique".split("").map((letter, idx) => (
              <motion.span
                key={idx}
                className="inline-block"
                initial={{ x: -10, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: idx * 0.04 }}
              >
                {letter}
              </motion.span>
            ))}
          </span>
        </motion.p>
        <motion.p 
          className="text-sm md:text-lg text-gray-500 max-w-2xl mx-auto py-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          Service rapide et professionnel dans toutes les régions de Belgique. 
          Intervention sous 2 heures en cas d'urgence.
        </motion.p>
      </div>
      
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <BelgiumMap
          dots={[
            {
              start: { lat: 50.8503, lng: 4.3517, label: "Bruxelles" }, // Brussels
              end: { lat: 51.2194, lng: 4.4025, label: "Anvers" }, // Antwerp
            },
            {
              start: { lat: 50.8503, lng: 4.3517, label: "Bruxelles" }, // Brussels
              end: { lat: 50.6292, lng: 5.5797, label: "Liège" }, // Liège
            },
            {
              start: { lat: 50.8503, lng: 4.3517, label: "Bruxelles" }, // Brussels
              end: { lat: 51.0543, lng: 3.7174, label: "Gand" }, // Ghent
            },
            {
              start: { lat: 50.8503, lng: 4.3517, label: "Bruxelles" }, // Brussels
              end: { lat: 50.4108, lng: 4.4446, label: "Charleroi" }, // Charleroi
            },
            {
              start: { lat: 51.2194, lng: 4.4025, label: "Anvers" }, // Antwerp
              end: { lat: 51.2093, lng: 3.2247, label: "Bruges" }, // Bruges
            },
            {
              start: { lat: 50.6292, lng: 5.5797, label: "Liège" }, // Liège
              end: { lat: 50.4674, lng: 4.8720, label: "Namur" }, // Namur
            },
          ]}
        />
      </div>
    </div>
  );
}